// extracted by mini-css-extract-plugin
module.exports = {"controls":"NewGoogleAdsAccount-module__controls___2h90a","connect":"NewGoogleAdsAccount-module__connect___2ROIB"};